import React from 'react';
import { getAccountDocTypes, saveDocTypes, TextDesc } from '@sp-firebase/docTypesFB';
import { TrashIcon } from '../../Dashboard/dashboard-components/DashboardNotifications/components/NotificationIcons';
import { Button, CircularProgress, Input } from '@mui/material';
import { allDocTypes } from '../../UploadManageFiles/upload-files-utils';
import { Cancel, Edit, Save } from '@mui/icons-material';

export const ManageDocTypesPop: React.FC<{ accountId: string }> = ({ accountId }) => {
  const [docTypes, setDocTypes] = React.useState<TextDesc[]>([]);
  const [addDoc, setAddDoc] = React.useState<TextDesc>({ text: '' });
  const [editDoc, setEditDoc] = React.useState<string>('');
  const [editingDoc, setEditingDoc] = React.useState<string>('');
  const [descDoc, setDescDoc] = React.useState<string>('');
  const [loading, setLoading] = React.useState<boolean>(false);

  React.useEffect(() => {
    const loadDocTypes = async (_accountId: string) => {
      setLoading(true);
      const docs = await getAccountDocTypes(_accountId);

      setDocTypes(docs?.length ? docs : allDocTypes);
      setLoading(false);
    };
    if (accountId) {
      loadDocTypes(accountId);
    }
  }, [accountId]);

  const onDelete = async (docType: string) => {
    setLoading(true);

    const updatedList = docTypes.filter(({ text }) => text !== docType);
    const docs = await saveDocTypes(accountId, updatedList);

    setDocTypes(docs?.length ? docs : allDocTypes);
    setLoading(false);
  };

  const saveNewDoc = async () => {
    setLoading(true);

    const result = await saveDocTypes(accountId, [...docTypes, addDoc]);

    setDocTypes(result || []);

    setAddDoc({ text: '', desc: '' });
    setLoading(false);
  };

  const toggleEdit = ({ text, desc }: TextDesc) => {
    setEditDoc(text);
    setEditingDoc(text);
    setDescDoc(desc || '');
  };

  const saveEdit = async () => {
    if (editingDoc) {
      setLoading(true);
      const updatedDocs = docTypes.map((d) => (d.text === editDoc ? { text: editingDoc, desc: descDoc } : d));
      const result = await saveDocTypes(accountId, updatedDocs);

      setDocTypes(result || []);
      toggleEdit({ text: '', desc: '' });
      setLoading(false);
    }
  };

  return (
    <div className="w-100 h-200 bg-white rounded shadow p-3 flex flex-col">
      {loading && <CircularProgress size={24} className="absolute align-middle justify-center" />}
      <h4>Doc Types of: {accountId}</h4>
      <div>
        {docTypes.map(({ text, desc }, i) => (
          <div key={i} className="flex p-3 gap-2 border-b justify-between">
            <div className="flex flex-col">
              {text === editDoc ? (
                <>
                  <Input onChange={({ target }) => setEditingDoc(target.value)} value={editingDoc} />
                  <Input onChange={({ target }) => setDescDoc(target.value)} value={descDoc} />
                </>
              ) : (
                <>
                  <p>{text}</p>
                  <p>{desc}</p>
                </>
              )}
            </div>
            <div className="flex gap-2">
              {editDoc === text ? (
                <>
                  <Save onClick={saveEdit} />
                  <Cancel onClick={() => toggleEdit({ text: '' })} />
                </>
              ) : (
                <>
                  <Edit onClick={() => toggleEdit({ text, desc })} />
                  <TrashIcon iconColor="#6571FF" onClick={() => onDelete(text)} />
                </>
              )}
            </div>
          </div>
        ))}
        <div className="flex p-3 gap-2 border-b justify-between">
          <p className="flex flex-col gap-2">
            <Input
              placeholder="text"
              onChange={({ target }) => setAddDoc(({ desc }) => ({ desc, text: target.value }))}
              value={addDoc.text}
            />
            <Input
              placeholder="description"
              onChange={({ target }) => setAddDoc(({ text }) => ({ text, desc: target.value }))}
              value={addDoc.desc}
            />
          </p>
          <Button variant="contained" onClick={saveNewDoc}>
            Add new
          </Button>
        </div>
      </div>
    </div>
  );
};
